/* WISHLIST PAGE */

// Callback function by smart wishlist app and called when the wishlist is loaded
function WishlistLoadedCallback() {
  /* TRANSLATIONS */
  $('.titletext').html(window.i18n.wishlist['title']);
  $('.sharebutton').html(window.i18n.wishlist['share']);
  $('.clearall').html(window.i18n.wishlist['clear_all']);
  $('.product .addsingleproduct').html(window.i18n.wishlist['add_to_cart']);
  $('.product .removebutton').html(window.i18n.wishlist['remove']);
  $('.alert.alert-info.empty-wishlist').html(window.i18n.wishlist['no_items']);
  $('.alert.alert-info.sw-login-notification').html(window.i18n.wishlist['login']);

  // Show header with text and button on content loaded
  $('#heading-breadcrumbs').addClass('show-title-wishlist');

  /* WISHLIST PAGE */

  // Add lines around buttons on wishlist page
  let wishlistPage = document.querySelector('.wishlistpage');
  let buttonsArray = new Array(); // Array where the buttons will be stored

  // Buttons
  let buttonShare = wishlistPage.querySelector('.sharebutton');
  let buttonClearAll = wishlistPage.querySelector('.clearall');

  // Button style
  let buttonStyleLine = '<div class="c-button__line-top-x"></div><div class="c-button__line-top-y"></div><div class="c-button__line-bottom-x"></div><div class="c-button__line-bottom-y"></div>';

  // Put all buttons on the array
  buttonsArray.push(buttonShare);
  buttonsArray.push(buttonClearAll);

  // For all buttons in the array, insert HTML and add classes
  const ModifyButtonStyle = buttonsArray.map(function (button) {
    applyStyle(button);
  });

  // Get the product button after wishlist page is loaded 
  let buttonsRemoveProduct = document.querySelectorAll('.product .singleremovebutton');
  let buttonsAddProduct = document.querySelectorAll('.product .addsingleproduct');
  for (var i = 0; i < buttonsRemoveProduct.length; i++) {
    applyStyle(buttonsRemoveProduct[i]);
  }
  for (var i = 0; i < buttonsAddProduct.length; i++) {
    applyStyle(buttonsAddProduct[i]);
  }
  function applyStyle(button) {
    button.insertAdjacentHTML("beforeend", buttonStyleLine);
    button.classList.add('c-button');
    button.classList.add('c-button--draw');
    button.classList.add('wishlist-btn');
  }
}